import { Col, Container, Row } from 'react-bootstrap';
import { Link as ScrollTo } from 'react-scroll';

const HeroSection = () => {
  return (
    <div className='relative overflow-hidden'>
      {/* Background Image with Dark Blackish Gradient */}
      <div
        className='absolute inset-0'
        style={{
          backgroundImage:
            "linear-gradient(to bottom, rgba(20, 10, 10, 0.8), rgba(20, 10, 10, 0.8)), url('/assets/img/about-us-page/about.jpg')",
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          zIndex: 0,
        }}
      ></div>

      {/* Content */}
      <Container className='relative'>
        <Row className='items-center justify-between pt-20 sm:!pt-16 h-[60vh] md:h-[calc(450px-80px)] sm:h-[calc(350px-80px)]'>
          <Col lg={12} md={12} sm={12}>
            <h3 className='font-roboto font-bold text-tprimary uppercase mb-[2.5rem] sm:mb-[20px] xs:mb-[15px] text-center'>
              About Us
            </h3>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default HeroSection;
